export default __webpack_public_path__ + "static/media/DisabledCreateBill.3fd8bc03.svg";